import React, {useState, useRef, useEffect} from "react"
import {useOutletContext, useNavigate} from "react-router-dom"
import api, {requestFailed} from "../Scripts/api"
import getSteps from "../Scripts/getSteps"
import TitleBar from "../Components/TitleBar"
import OptionBar from "../Components/OptionBar"
import StepList from "../Components/StepList"
import Loading from "../Components/Loading"

function Home() {

    const oc = useOutletContext().oc
	const navigate = useNavigate()
    const [state, setState] = useState("start")
    const [prompt, setPrompt] = useState(null)
    const [choice, setChoice] = useState(null)
    const divRef = useRef(null)
    const [steps, setSteps] = useState(null);
    const [lastChoice, setLastChoice] = useState(choice)
    const [stepsError, setStepsError] = useState(false)

    const handlePrompt = (input) => setPrompt(input)

    const handleChoice = (input) => setChoice(input)

    const getStepsCall = async () => {
        setStepsError(false)
        const gotSteps = await getSteps(prompt, choice)
        if (gotSteps) setSteps(gotSteps)
        else setStepsError(true)
    }

    const save = () => {
        const poststeps = steps.map(({"step number": stepNumber, ...rest}) => rest)

        api.post(`/api/createpost`, {
            authorID: 0,
            title: "LVL UP " + choice,
            author: "AI",
            steps: poststeps,
            tags: [choice.replace(/\s+/g, "-")]
        }).then((response) => {
            if (response.data.url) navigate("/post/" + response.data.url)
        }).catch(requestFailed)
    }

    useEffect(() => {
        if (state == "steps") {
            const element = divRef.current

            if (choice != lastChoice) {
                setSteps(null)
                setLastChoice(choice)
                getStepsCall()
            }
            
            if (steps) {
                element.style.height = '0'
                element.style.overflow = "hidden"
                element.style.opacity = '0'
                requestAnimationFrame(() => {
                    element.style.height = element.scrollHeight + "px"
                    element.style.opacity = '1'
                })
                const autoHeight = setTimeout(() => {
                    element.style.height = "auto"
                }, 2050)
                return () => {
                    clearTimeout(autoHeight)
                }
            }
        }
    }, [choice, steps])

    return (
        <div>
            <TitleBar state={state} navOpen={oc.navOpen} setPrompt={handlePrompt} showOptions={() => setState("options")}/>
            {state != "start" && 
                <OptionBar state={state} prompt={prompt} setChoice={handleChoice} showSteps={() => setState("steps")}/>
            }
            {state === "steps" && steps &&
                <div ref={divRef} id="steplist">
                    <StepList steps={steps}/>
                </div>
            }
            {state === "steps" && steps &&
                <button id="createpost" onClick={save}>+ save</button>
            }
            {state == "steps" && !steps && stepsError &&
                <div id="steperror">
                    <p>something went wrong generating steps.</p>
                    <button onClick={getStepsCall}>retry</button>
                </div>
            }
            {state == "steps" && !steps && !stepsError &&
                <Loading/>
            }
        </div>
    )
}

export default Home;
